'use strict';

var react = require('@emotion/react');

const qualityBadge = /*#__PURE__*/ react.css({
    height: "24px",
    width: "24px"
}, "label:label-QualityBadge-web-stylesqualityBadge", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvcGxhdGZvcm0vUXVhbGl0eUJhZGdlL1F1YWxpdHlCYWRnZS53ZWIuc3R5bGVzLnRzIiwic291cmNlcyI6WyIvVXNlcnMvaWFuY2xhcmtlL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9RdWFsaXR5QmFkZ2UvUXVhbGl0eUJhZGdlLndlYi5zdHlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5cbmV4cG9ydCBjb25zdCBxdWFsaXR5QmFkZ2UgPSBjc3Moe1xuICBoZWlnaHQ6IFwiMjRweFwiLFxuICB3aWR0aDogXCIyNHB4XCIsXG59KTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIifQ== */");

exports.qualityBadge = qualityBadge;
//# sourceMappingURL=QualityBadge.web.styles.cjs.map
